import { QueryClient } from "@tanstack/react-query";
import { ApiError } from "./axiosClient";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      gcTime: 1000 * 60 * 30, // 30 minutes (formerly cacheTime)
      retry: (failureCount, error) => {
        // Don't retry on 4xx client errors
        if (error instanceof ApiError && error.isClientError()) {
          return false;
        }
        // 5xx 서버 에러 및 네트워크 에러는 최대 3번까지 재시도
        return failureCount < 3;
      },
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
});

// Query key factory pattern
export const queryKeys = {
  all: ["all"] as const,
  auth: {
    all: ["auth"] as const,
    me: () => [...queryKeys.auth.all, "me"] as const,
  },
};
